import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ContactsComponent } from 'src/app/cms/contacts/contacts.component';
import { ContactComponent } from 'src/app/cms/contact/contact.component';
import { ContactResolve } from 'src/app/cms/contact/contact-resolve.service';
import { GroupParentComponent } from './group/group-parent.component';
import { GroupsResolve } from './groups/groups-resolve.service';
import { GroupsComponent } from './groups/groups.component';
import { ContactsResolve } from './contacts/contacts-resolve.service';
import { GroupResolve } from './group/group-parent-resolve.service';
import { InsurancesPickerResolve } from './contacts/insurances-resolve.service';
import { SpecialtiesPickerResolve } from './contacts/specialties-resolve.service';
import { FacilitiesComponent } from './facilities/facilities.component';
import { FacilitiesResolve } from './facilities/facilities-resolve.service';
import { FacilitiesInsurancesPickerResolve } from './facilities/insurances-resolve.service';
import { FacilityResolve } from './facility/facility-resolve.service';
import { FacilityComponent } from './facility/facility.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { CitiesPickerResolve } from './facilities/cities-resolve.service';
import { CitiesComponent } from './cities/cities.component';
import { SpecialtiesComponent } from './specialties/specialties.component';
import { InsurancesComponent } from './insurances/insurances.component';
import { DepartmentsComponent } from './departments/departments.component';
import { DepartmentsResolve } from './contacts/departments-resolve.service';
import { FacilitiesDepartmentsResolve } from './facilities/departments-resolve.service';
import { RegionsComponent } from './regions/regions.component';
import { RegionsResolve } from './contacts/regions-resolve.service';


const routes: Routes = [
  {
    path: 'groups',
      component: GroupsComponent,
      resolve: {
        groups: GroupsResolve
      }
  },
  {
    path: 'groups/:id',
    component: GroupParentComponent,
    resolve: {
      group: GroupResolve,
      groups: GroupsResolve, 
    },
    children: [
      { path: '', redirectTo: 'contacts', pathMatch: 'full' },
      {
        path: 'dashboard',
        component: DashboardComponent,
        resolve: {
          contacts: ContactsResolve,
          insurances: InsurancesPickerResolve,
          specialties: SpecialtiesPickerResolve,
          facilities: FacilitiesResolve,
          facilitiesInsurances: FacilitiesInsurancesPickerResolve,
        }
      },
      {
        path: 'contacts',
        component: ContactsComponent,
        runGuardsAndResolvers: `always`,
        resolve: {
          contacts: ContactsResolve,
          insurances: InsurancesPickerResolve,
          specialties: SpecialtiesPickerResolve,    
        }
      },
      {
        path: 'contacts/:id',
        component: ContactComponent,
        resolve: {
          contact: ContactResolve
        }
      },
      {
        path: 'contact/specialty-list',
        component: SpecialtiesComponent,
        resolve: {
          specialties: SpecialtiesPickerResolve
        }
      },
      {
        path: 'contact/insurance-list',
        component: InsurancesComponent,
        resolve: {
          insurances: InsurancesPickerResolve
        }
      },
      {
        path: 'contact/department-list',
        component: DepartmentsComponent,
        resolve: {
          departments: DepartmentsResolve
        }
      },
      {
        path: 'contact/regions',
        component: RegionsComponent,
        resolve: {
          regions: RegionsResolve
        }
      },
      {
        path: 'facilities',
        component: FacilitiesComponent,
        resolve: {
          facilities: FacilitiesResolve,
          insurances: FacilitiesInsurancesPickerResolve,
          cities: CitiesPickerResolve,
        }
      },
      {
        path: 'facilities/:id',
        component: FacilityComponent,
        resolve: {
          facility: FacilityResolve
        }
      },
      {
        path: 'facility/insurance-list',
        component: InsurancesComponent,
        resolve: {
          insurances: FacilitiesInsurancesPickerResolve
        }
      },
      {
        path: 'facility/department-list',
        component: DepartmentsComponent,
        resolve: {
          departments: FacilitiesDepartmentsResolve
        }
      },
      {
        path: 'facility/regions',
        component: RegionsComponent,
        resolve: {
          regions: RegionsResolve
        }
      },
      {
        path: 'facility/city-list',
        component: CitiesComponent,
        resolve: {
          cities: CitiesPickerResolve
        }
      },
      { path: '**', redirectTo: 'contacts' }
    ]
  }
  
]

@NgModule({
  imports: [
    RouterModule.forChild(routes),
  ],
  exports: [
    RouterModule
  ],
  declarations: []
})
export class CmsRoutingModule { }

export const routedComponents = [
  GroupsComponent,
  ContactsComponent,
  ContactComponent,
  GroupParentComponent,
  FacilitiesComponent,
  FacilityComponent
];
